<div class="body">
  <div class="preview-img">
    @if (isDarkTheme()) {
      <img
        ngSrc="../../../assets/images/pwa/preview-dark.png"
        srcset="
          assets/images/pwa/preview-dark.png     400w,
          assets/images/pwa/preview@x2-dark.png  800w,
          assets/images/pwa/preview-mob-dark.png 343w
        "
        sizes="(max-width: 600px) 100vw, (min-width: 601px) 50vw"
        alt="Refresh"
        height="225"
        width="400"
        priority
      />
    } @else {
      <img
        ngSrc="../../../assets/images/pwa/preview-light.png"
        srcset="
          ../../../assets/images/pwa/preview-light.png     400w,
          ../../../assets/images/pwa/preview@x2-light.png  800w,
          ../../../assets/images/pwa/preview-mob-light.png 343w
        "
        sizes="(max-width: 600px) 100vw, (min-width: 601px) 50vw"
        alt="Refresh"
        height="225"
        width="400"
        priority
      />
    }
  </div>

  <div class="d-flex flex-col">
    @if (isIOS) {
      <p class="title">
        {{ "pwaSetupDialog.mobileApp.ios.title" | translate }}
      </p>
    } @else {
      <p class="title">
        {{ "pwaSetupDialog.mobileApp.otherDevice.title" | translate }}
      </p>
    }
    <p class="subtitle mt-2">
      {{ "pwaSetupDialog.allDevices.subTitle" | translate }}
    </p>
  </div>

  <div class="d-flex flex-col gap-2">
    @if (isIOS) {
      <p class="step">
        <fu-icon class="step-icon" iconName="upload" size="24" />
        <span>{{ "pwaSetupDialog.ios.setupStep1" | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="plus-outlined" size="24" />
        <span>{{ "pwaSetupDialog.ios.setupStep2" | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="check-done" size="24" />
        <span>{{ "pwaSetupDialog.ios.setupStep3" | translate }}</span>
      </p>
    } @else {
      <p class="step">
        <fu-icon class="step-icon" iconName="dots-vertical" size="24" />
        <span>{{ "pwaSetupDialog.otherDevice.setupStep1" | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="install" size="24" />
        <span>{{ "pwaSetupDialog.otherDevice.setupStep2" | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="check-done" size="24" />
        <span>{{ "pwaSetupDialog.otherDevice.setupStep3" | translate }}</span>
      </p>
    }
  </div>
  @if (canInstallPwa() || isInstalling()) {
    <div class="d-flex flex-col gap-3 justify-center">
      <hr class="divider" />
      <span class="subtitle">{{
        "pwaSetupDialog.allDevices.setupStep4" | translate
      }}</span>
      <iw-button size="m" fullWidth uiType="primary" (click)="installPwa()">
        {{ "pwaSetupDialog.mobileApp.btn.install" | translate }}
      </iw-button>
    </div>
  }
</div>
